// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Aruba from '../_raw/flag/icon_flag_aruba.png';

export default () => <img src={Aruba} alt="Aruba" />;
